// extracted by mini-css-extract-plugin
module.exports = {"noteContainer":"NoteInput_noteContainer__35zt_","noteWrapper":"NoteInput_noteWrapper__op-sG","noteInput":"NoteInput_noteInput__1CY0F","highlight":"NoteInput_highlight__3iRLs"};